import {
  FETCH_LOCATIONS,
  CREATE_LOCATIONS
} from './mutations-types'

export default {
  [FETCH_LOCATIONS] (state, payload) {
    state.locations = payload
  },
  [CREATE_LOCATIONS] (state, payload) {
    state.locations.push(payload)
  }
}
